import { render, staticRenderFns } from "./CategoryDetails.vue?vue&type=template&id=dcb9db9e&scoped=true"
import script from "./CategoryDetails.vue?vue&type=script&lang=js"
export * from "./CategoryDetails.vue?vue&type=script&lang=js"
import style0 from "./CategoryDetails.vue?vue&type=style&index=0&id=dcb9db9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcb9db9e",
  null
  
)

export default component.exports